import { FC, useState } from 'react'
import {Field, ErrorMessage, FormikProps} from 'formik'
import { initValuesParticipante, IWizardModel } from '../helpers/PesquisaHelper'
import { useAlert, useHelper, useHttpClient } from '../../../../modules/services/Bundle'
import { EnumTipoDisparo, EnumPesquisaStatus, RequestMethod } from '../../../../modules/services/core/_enums'
import { IconButton } from '@mui/material'
import { KTSVG } from '../../../../../_metronic/helpers'
import { FileModel } from '../../../../modules/services/core/_models'

interface Step3Props {
  formik: FormikProps<IWizardModel>,
}

export const ModalEnvioOptions = [
  { value: 1, label: 'E-mail' },
  { value: 2, label: 'WhatsApp' },
];

const Step3: FC<Step3Props> = ({
  formik,
}) => {
  const httpClient = useHttpClient()
  const alert = useAlert()
  let [abrirModal, setAbrirModal] = useState(false)
  const [acaoSelecionada, setAcaoSelecionada] = useState('');
  const helper = useHelper()

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  const file = e.target.files?.[0];
  if (!file) return;

    const reader = new FileReader();
    reader.onload = () => {
      const result = reader.result as string;
      const base64 = result.split(',')[1]; // Remove o prefixo "data:...;base64,"

    const arquivoVM = {
      Nome: file.name,
      Extensao: file.name.split('.').pop() || '',
      Tamanho: file.size,
      Tipo: file.type,
      Base64: base64,
      };

      formik.setFieldValue('Arquivo', arquivoVM);
    };
    reader.readAsDataURL(file);
  };

const executarAcao = async () => {
  if (acaoSelecionada === 'exportar') {
    try {
      const response = await httpClient.request({
        method: RequestMethod.GET,
        endpoint: '/Pesquisa/Pesquisa/exportarModelo',
      });

      if (response.success && response.payload) {
        const file: FileModel = response.payload;
        await helper.downloadFile(file);
      }
    } catch (error) {
      console.error("Erro ao exportar o modelo:", error);
      alert.createMessage({
        html: "Erro ao exportar o modelo.",
        icon: 'error',
      })
    }
  } else if (acaoSelecionada === 'importar') {
      const arquivoVM = formik.values.Arquivo;

      alert.createDialog({
        html: 'Deseja importar os participantes da planilha?',
        confirmAction: async () => {
          if (!arquivoVM) {
            alert.createMessage({
              html: 'Nenhum arquivo foi selecionado.',
              icon: 'error',
            })
            return;
          }

          const response = await httpClient.request({
            method: RequestMethod.POST,
            endpoint: '/Pesquisa/Pesquisa/importarParticipantes',
            data: arquivoVM,
          });

          if (response.success && response.payload) {
            const novosParticipantes = response.payload;
            
            formik.setFieldValue('Participantes', novosParticipantes);

            alert.createMessage({
              html: 'Participantes importados com sucesso!',
              icon: 'success',
            })
            setAbrirModal(false);
          } else {
            alert.createMessage({
              html: 'Erro ao importar participantes!',
              icon: 'error',
            })
          }
        },
      });


  }
};

  const onClickAdicionarParticipante = async () => {
    if (formik.isValid) {
      const response = await httpClient.request({
        method: RequestMethod.GET,
        endpoint: '/Pesquisa/Pesquisa/VerificarQtdMaximaParticipantes',
        queryObject: {
          qtdParticipantes: formik.values.Participantes.length
        },
      })

      if (response.success ) {
        const newValues = formik.values
        newValues.Participantes.push(initValuesParticipante)
        formik.setValues(newValues)
      }
    } else {
      alert.createMessage({
        html: `Deve preencher todos os dados antes de adicionar um novo campo!`,
      })
    }

  }

  const onClickRemoverParticipante = (index:number) => {
    const newValues = formik.values
    if (newValues.Participantes.length > 1) {
      newValues.Participantes.splice(index, 1)
      formik.setValues(newValues)
    } else{
      alert.createMessage({
        html: `Deve haver ao menos um participante!`,
      })
    }
  }

  const isCampoObrigatorio = (campo: 'Email' | 'Telefone') => {
  return (
    (campo === 'Email' && formik.values.TipoDisparo === EnumTipoDisparo.Email) ||
    (campo === 'Telefone' && formik.values.TipoDisparo === EnumTipoDisparo.WhatsApp)
  );
};


  return (
    <>
      <div className='w-100 '>   
        <div 
          className='w-100 mb-5 scroll scroll-height-step-4 h-475px '
        >
          <div key={`accordion-participantes`} id={`accordion-participantes`} className=' w-100'>
            <div className={`card card-custom border border-secondary border-1 shadow-sm titulo-pesquisa-nao-selecionado`}>
              <div className="card-header bg-pesquisa border-bottom border-secondary border-1 rounded-bottom" id={`card-titulo-header-participantes`}>
                <div className="card-title">
                  <h3 className='text-white'>Informe os participantes da pesquisa: <span className='text-white'>{formik.values.Nome}</span></h3>                                
                </div>
                <div className="card-toolbar w-md-auto">     
                    {formik.values.Status !== EnumPesquisaStatus.Finalizada && formik.values.Status !== EnumPesquisaStatus.EmAndamento && (
                        <button type="button" onClick={() => setAbrirModal(true)} className="btn btn-lg btn-accordion btn-light mx-2">
                            Importar Participantes
                        </button>
                    )} 

                    {formik.values.Status !== EnumPesquisaStatus.Finalizada && formik.values.Status !== EnumPesquisaStatus.EmAndamento && (
                    <button type="button" onClick={() => onClickAdicionarParticipante()} className="btn btn-icon btn-sm btn-accordion btn-light">
                      <i className='fas fa-plus fs-1'></i>
                    </button>
                    )}  

                </div>
              </div>
              <div id={`card-titulo-collapse-participantes`} className="collapse show" aria-labelledby={`card-titulo-header-participantes`} data-bs-parent={`#accordion-participantes`}>
                <div className="card-body">
                  {formik.values.Participantes && formik.values.Participantes.length > 0 && formik.values.Participantes.map((participante, participanteIndex) => { 
                    return <div key={`participante-${participanteIndex}`} className={`row`}>
                      <div className='col-lg-3 mb-5'>
                        <label className='form-label required ms-5' hidden={participanteIndex > 0}>&nbsp;Nome</label>
                        <Field 
                          name={`Participantes.${participanteIndex}.Nome`}
                          maxLength={60}
                          placeholder='Nome'
                          className='form-control form-control-lg'
                          value={participante.Nome}
                          disabled={formik.values.Status === EnumPesquisaStatus.Finalizada || formik.values.Status === EnumPesquisaStatus.EmAndamento}
                        />
                        <div className='text-danger mt-2'>
                          <ErrorMessage name={`Participantes.${participanteIndex}.Nome`}/>
                        </div>
                      </div>

                      <div className='col-lg-4 mb-5'>
                        <label className={`form-label ms-5 ${isCampoObrigatorio('Email') ? 'required' : ''}`} hidden={participanteIndex > 0}>&nbsp;E-mail</label>
                        <Field 
                          name={`Participantes.${participanteIndex}.Email`}
                          maxLength={60}
                          placeholder='E-mail'
                          className='form-control form-control-lg'
                          value={participante.Email}
                          disabled={formik.values.Status === EnumPesquisaStatus.Finalizada || formik.values.Status === EnumPesquisaStatus.EmAndamento}
                        />
                        <div className='text-danger mt-2'>
                          <ErrorMessage name={`Participantes.${participanteIndex}.Email`}/>
                        </div>
                      </div>

                      <div className='col-lg-4 mb-5'>
                        <label className={`form-label ms-5 ${isCampoObrigatorio('Telefone') ? 'required' : ''}`} hidden={participanteIndex > 0}>&nbsp;Telefone</label>
                        <Field 
                          name={`Participantes.${participanteIndex}.Telefone`}
                          maxLength={60}
                          placeholder='Numero de Telefone'
                          className='form-control form-control-lg'
                          value={participante.Telefone}
                          disabled={formik.values.Status === EnumPesquisaStatus.Finalizada || formik.values.Status === EnumPesquisaStatus.EmAndamento}
                        />
                        <div className='text-danger mt-2'>
                          <ErrorMessage name={`Participantes.${participanteIndex}.Telefone`}/>
                        </div>
                      </div>

                      {((formik.values.Status !== EnumPesquisaStatus.Suspensa && formik.values.Status !== EnumPesquisaStatus.Finalizada && formik.values.Status !== EnumPesquisaStatus.EmAndamento) || (formik.values.Status === EnumPesquisaStatus.Suspensa && participante.Id === 0) )&& (
                        <div className='col-lg-1 mb-5 mt-5 d-flex align-items-center justify-content-end '>
                          <IconButton className='icon-button-dark-hover' onClick={() => onClickRemoverParticipante(participanteIndex)} color="primary" aria-label="upload picture" component="label"
                          >
                            <KTSVG path="/media/icons/duotune/general/gen034.svg" className="svg-icon-muted svg-icon-2hx text-danger " />
                          </IconButton>
                        </div>
                      )}
                    </div>
                  })}
                </div>   
              </div>                         
            </div>
          </div>
        </div>
        <div className='row'>
          <div className='col-lg-12 mb-5 d-flex'>
            <h3 className='stepper-title text-start mt-3 me-2'>
              Nº mínimo de respondentes da pesquisa para apresentação dos resultados:
            </h3>
            <div style={{ width: '10%' }}>
              <Field
                type='number'
                name='QtdMinRespParaMostrarResultados'
                placeholder='Qtd mínima'
                className='form-control form-control-lg'
                value={formik.values.QtdMinRespParaMostrarResultados}
                disabled={
                  formik.values.Status === EnumPesquisaStatus.Finalizada ||
                  formik.values.Status === EnumPesquisaStatus.EmAndamento
                }
              />
            </div>
          </div>
          <div className='text-danger'>
            <ErrorMessage name='QtdMinRespParaMostrarResultados' />
          </div>

          <div className='col-lg-4 mb-5'>
            <h3 className='stepper-title text-start mt-3 me-2'>Modo de Envio</h3>
            <div>

              <Field
                as="select"
                name="TipoDisparo"
                className="form-select form-select-lg"
                value={formik.values.TipoDisparo ?? 0}
                onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                  formik.setFieldValue('TipoDisparo', parseInt(e.target.value));
                }}
                disabled={
                  formik.values.Status === EnumPesquisaStatus.Finalizada ||
                  formik.values.Status === EnumPesquisaStatus.EmAndamento
                }
              >
                <option value={0}>Selecione...</option>
                {ModalEnvioOptions.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </Field>

            </div>
            <div className='text-danger mt-2'>
              <ErrorMessage name='TipoDisparo' />
            </div>
          </div>
        </div>
      </div>

      <div className={`modal ${abrirModal ? "show" : ""} fade`} tabIndex={-1} id="kt_modal_1" style={{ display: abrirModal ? "block" : "none" }}>
        <div className="modal-dialog modal-dialog-centered modal-md">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Importar Participantes</h5>
              <div
                onClick={() => setAbrirModal(false)}
                className="btn btn-icon btn-sm btn-active-light-primary ms-2"
                aria-label="Fechar"
              >
                <KTSVG
                  path="/media/icons/duotune/arrows/arr061.svg"
                  className="svg-icon svg-icon-2x"
                />
              </div>
            </div>
            <div className="modal-body">

              <div className="w-100 mb-4">
                <label className="form-label fw-bold">Selecione uma ação:</label>
                <select className="form-select" value={acaoSelecionada} onChange={(e) => setAcaoSelecionada(e.target.value)}>
                  <option value="">Selecione</option>
                  <option value="exportar">Exportar Planilha Modelo</option>
                  <option value="importar">Importar Planilha</option>
                </select>
              </div>

              {acaoSelecionada === 'importar' && (
                <div className="w-100 mb-4">
                  <label className="form-label fw-bold">Escolha o arquivo Excel:</label>
                  <input type="file" accept=".xls,.xlsx" onChange={handleFileChange} />
                </div>
              )}

            </div>
            <div className="modal-footer">
              <div className="d-flex">
                <button onClick={() => setAbrirModal(false)} type="button" className="btn btn-light me-5 mx-1">
                  Cancelar
                </button>

                <button type="button" className="btn btn-pesquisa mx-1" onClick={executarAcao}>
                  Executar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

    </>
  )
} 


export {Step3}
